import axios from "axios";
import { REACT_APP_API_URL } from "../api/global";

export const fetchBannerCarouselData = (token, page) => async (dispatch) => {
  dispatch({ type: "FETCH_CAROUSEL_REQUEST" });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/getAllBannersData`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: "FETCH_CAROUSEL_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_CAROUSEL_FAILURE",
      payload: error.message,
    });
  }
};
